import DataDisplayRowI from "../DataDisplayRowI";
import getCorporateRow from "../DataDisplayRow/CorporateRow";
import DataDisplayTable from "../DataDisplayTable";

class CorporateTable extends DataDisplayTable {
    #row!: DataDisplayRowI;

    generateRow(): DataDisplayRowI {
        return this.#row = getCorporateRow()
    }
}

let corporateTable: CorporateTable | null = null;

export default function getCorporateTable(): CorporateTable {
    if (corporateTable === null)
        corporateTable = new CorporateTable()
    return corporateTable
}